export default __webpack_public_path__ + "static/users-love-us.webp";